import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';
import { RentalPeriodModel } from './../../models/rental/rental-period.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';

@Injectable({
  providedIn: 'root'
})
export class RentalPeriodService {

  constructor(private _httpClient: HttpClient) { }

  createRentalPeriod(rentalPeriodModel: RentalPeriodModel): Observable<RentalPeriodModel> {
    return this._httpClient.post<RentalPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.CreateRentalPeriod}`,
      rentalPeriodModel);
  }

  deleteRentalPeriod(rentalPeriodId: number): Observable<RentalPeriodModel> {
    return this._httpClient.delete<RentalPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.DeleteRentalPeriod}/${rentalPeriodId}`);
  }

  exportDocumentsForDelete(columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.ExportDocumentsForDelete}`, null,
      {
        params,
        responseType: 'blob',
      }
    );
  }

  exportDocumentsOpenedConsultation(columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.ExportDocumentsOpenedConsultation}`, null,
      {
        params,
        responseType: 'blob',
      }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllDocumentsForDeleteWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetAllDocumentsForDeleteWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllDocumentsOpenedWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetAllDocumentsOpenedWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllRentalPeriodsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetAllRentalPeriodsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetColumnsForGeneralConsultationAsync}`);
  }

  getColumnsForDocumentsOpened(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetColumnsForDocumentsOpenedAsync}`);
  }

  getLastRentalPeriod(branchId: number): Observable<RentalPeriodModel> {
    return this._httpClient.get<RentalPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetLastRentalPeriod}/${branchId}`);
  }

  getRentalPeriodById(rentalPeriodId: number): Observable<RentalPeriodModel> {
    return this._httpClient.get<RentalPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetRentalById}/${rentalPeriodId}`);
  }

  getRentalPeriodWithState(rentalPeriodId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.GetRentalPeriodWithState}/${rentalPeriodId}`);
  }

  setActiveRentalPeriod(rentalPeriodId: number): Observable<RentalPeriodModel> {
    return this._httpClient.put<RentalPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalPeriod.SetActiveRentalPeriod}/${rentalPeriodId}`,
      null);
  }
}
